<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-6 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="use1">
        <input type="checkbox" class="custom-control-input mgntp10" id="use1" value='Separate contracts for each location' name="home_use"
          [(ngModel)]="hgContracts.use1"
          (click)="getSpecial_contracts($event)" />
        <label class="custom-control-label font20" for="use1">Separate contracts for each location</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use2">
        <input type="checkbox" class="custom-control-input mgntp10" id="use2" value="Separate invoices for each location" name="home_use"
          [(ngModel)]="hgContracts.use2" (click)="getSpecial_contracts($event)" />
        <label class="custom-control-label font20" for="use2">Separate invoices for each location</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use3">
        <input type="checkbox" class="custom-control-input mgntp10" id="use3" value="Single contract for all locations" name="home_use"
          [(ngModel)]="hgContracts.use3"
          (click)="getSpecial_contracts($event)" />
        <label class="custom-control-label font20" for="use3">Single contract for all locations</label>
      </label>
      <label class="custom-control custom-checkbox chkbox mb-2" for="use4">
        <input type="checkbox" class="custom-control-input mgntp10" id="use4" value="Consolidated billing" name="home_use"
          name="home_use" [(ngModel)]="hgContracts.use4"
          (click)="getSpecial_contracts($event)" />
        <label class="custom-control-label font20" for="use4">Consolidated billing</label>
      </label>
    </div>
    <button class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [disabled]="isDisable"
      [ngClass]="{'combtn': user_bot}" (click)="next();">Next</button>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <label class="custom-control custom-checkbox chkbox mb-2" for="use1_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use1_mob" value='Separate contracts for each location' name="home_use"
        [(ngModel)]="hgContracts.use1"
        (click)="getSpecial_contracts($event)" />
      <label class="custom-control-label font20" for="use1_mob">Separate contracts for each location</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use2_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use2_mob" value="Separate invoices for each location" name="home_use"
        [(ngModel)]="hgContracts.use2" (click)="getSpecial_contracts($event)" />
      <label class="custom-control-label font20" for="use2_mob">Separate invoices for each location</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use3_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use3_mob" value="Single contract for all locations" name="home_use"
        [(ngModel)]="hgContracts.use3"
        (click)="getSpecial_contracts($event)" />
      <label class="custom-control-label font20" for="use3_mob">Single contract for all locations</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="use4_mob">
      <input type="checkbox" class="custom-control-input mgntp10" id="use4_mob" value="Consolidated billing" name="home_use"
        [(ngModel)]="hgContracts.use4" (click)="getSpecial_contracts($event)" />
      <label class="custom-control-label font20" for="use4_mob">Consolidated billing</label>
    </label>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
      <div class="arrow_box">
        <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
      </div>
    </div>
  </div>
</div>